import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface ComponentCanDeactivateByField {
  preventNavigationFrom: boolean;
}

@Injectable()
export class PendingChangesActionGuard implements CanDeactivate<ComponentCanDeactivateByField> {
  canDeactivate(component: ComponentCanDeactivateByField): boolean | Observable<boolean> {
    return component.preventNavigationFrom ?
      confirm('You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.') : true;
  }
}
